class StickyVariantDrawer {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.openCartDrawer = root.dataset.openCartDrawer === 'true';

    this.triggerButton = root.querySelector('.sticky-variant-drawer__trigger');
    this.quantityInput = root.querySelector('.sticky-variant-drawer__quantity .quantity__input');
    this.quantityButtons = root.querySelectorAll('.sticky-variant-drawer__quantity .quantity__button');
    this.panel = root.querySelector('.sticky-variant-drawer__panel');
    this.variantItems = Array.from(root.querySelectorAll('.sticky-variant-drawer__variant-item'));

    this.cartDrawer = document.querySelector('cart-drawer');

    this.productFormButtons = document.querySelector('.product-form__buttons');

    this.bindEvents();
  }

  bindEvents() {
    if (this.triggerButton) {
      this.triggerButton.addEventListener('click', () => {
        if (this.panel.classList.contains('sticky-variant-drawer__panel--open')) {
          this.closePanel();
        } else {
          this.openPanel();
        }
      });
    }

    this.variantItems.forEach((item) => {
      item.addEventListener('click', () => this.onVariantClick(item));
    });

    this.quantityButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.adjustQuantity(btn.name === 'plus' ? 1 : -1);
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.panel || this.panel.hidden) return;
      const target = event.target;
      if (this.root.contains(target)) return;
      this.closePanel();
    });

    this.initVisibilityObserver();
  }

  initVisibilityObserver() {
    if (!this.productFormButtons) {
      // 没有找到表单按钮时，保持默认隐藏，避免一开始就出现
      return;
    }

    this.hasScrolledPastOnce = false;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledDown = window.scrollY > 0;

            if (!entry.isIntersecting && scrolledDown) {
              // 记录已经滑过一次
              this.hasScrolledPastOnce = true;
            }

            if (this.hasScrolledPastOnce) {
              if (entry.isIntersecting) {
                // 回到表单区域：隐藏吸底栏
                this.root.classList.add('sticky-variant-drawer--hidden');
                this.root.classList.remove('sticky-variant-drawer--visible');
                this.closePanel();
              } else {
                // 表单区域不在视口内且已经滑动过：显示吸底栏
                this.root.classList.remove('sticky-variant-drawer--hidden');
                this.root.classList.add('sticky-variant-drawer--visible');
              }
            }
          });
        },
        {
          threshold: 0,
        }
      );

      observer.observe(this.productFormButtons);
    } else {
      // 兼容老浏览器：简单用滚动位置判断
      const toggleOnScroll = () => {
        if (window.scrollY <= 0) return;
        const rect = this.productFormButtons.getBoundingClientRect();
        if (rect.bottom <= 0) {
          this.root.classList.remove('sticky-variant-drawer--hidden');
          this.root.classList.add('sticky-variant-drawer--visible');
        } else {
          this.root.classList.add('sticky-variant-drawer--hidden');
          this.root.classList.remove('sticky-variant-drawer--visible');
          this.closePanel();
        }
      };

      window.addEventListener('scroll', toggleOnScroll, { passive: true });
      toggleOnScroll();
    }
  }

  openPanel() {
    if (!this.panel) return;
    this.panel.hidden = false;
    this.panel.classList.add('sticky-variant-drawer__panel--open');
    this.triggerButton?.setAttribute('aria-expanded', 'true');
  }

  closePanel() {
    if (!this.panel) return;
    this.panel.classList.remove('sticky-variant-drawer__panel--open');
    this.panel.hidden = true;
    this.triggerButton?.setAttribute('aria-expanded', 'false');
  }

  adjustQuantity(delta) {
    if (!this.quantityInput) return;
    const current = parseInt(this.quantityInput.value || '1', 10);
    const next = Math.max(1, current + delta);
    this.quantityInput.value = next;
  }

  async onVariantClick(item) {
    const available = item.dataset.variantAvailable === 'true';
    if (!available) return;

    const variantId = item.dataset.variantId;
    const quantity = this.quantityInput ? parseInt(this.quantityInput.value || '1', 10) : 1;

    if (!variantId) return;

    item.classList.add('loading');

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        console.error(data.description || data.message || 'Error adding to cart');
        return;
      }

      if (this.cartDrawer && this.openCartDrawer) {
        const cartDrawerSection = await fetch(`?section_id=cart-drawer`);
        const cartDrawerHtml = await cartDrawerSection.text();
        const cartIconSection = await fetch(`?section_id=cart-icon-bubble`);
        const cartIconHtml = await cartIconSection.text();

        const parsedState = {
          sections: {
            'cart-drawer': cartDrawerHtml,
            'cart-icon-bubble': cartIconHtml,
          },
        };

        if (typeof this.cartDrawer.renderContents === 'function') {
          this.cartDrawer.renderContents(parsedState);
        }
      }

      this.closePanel();
    } catch (error) {
      console.error('Error adding variant to cart', error);
    } finally {
      item.classList.remove('loading');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.sticky-variant-drawer')
    .forEach((root) => new StickyVariantDrawer(root));
});
